var map = {
	"./$pac.png": 67218,
	"./0xbtc.png": 53141,
	"./1inch.png": 91669,
	"./2give.png": 46493,
	"./aave.png": 13423,
	"./abt.png": 65459,
	"./act.png": 26792,
	"./actn.png": 6516,
	"./ada.png": 53340,
	"./add.png": 83585,
	"./adx.png": 45,
	"./ae.png": 19832,
	"./aeon.png": 16391,
	"./aeur.png": 69349,
	"./agi.png": 49617,
	"./agrs.png": 98163,
	"./aion.png": 96915,
	"./algo.png": 11535,
	"./amb.png": 1200,
	"./amp.png": 28146,
	"./ampl.png": 69460,
	"./ankr.png": 51328,
	"./ant.png": 359,
	"./ape.png": 63164,
	"./apex.png": 78510,
	"./appc.png": 84094,
	"./ardr.png": 91721,
	"./arg.png": 6488,
	"./ark.png": 76180,
	"./arn.png": 18521,
	"./arnx.png": 88773,
	"./ary.png": 77078,
	"./ast.png": 54072,
	"./atlas.png": 84581,
	"./atm.png": 33184,
	"./atom.png": 81821,
	"./audr.png": 87742,
	"./aury.png": 76507,
	"./auto.png": 33755,
	"./avax.png": 52544,
	"./aywa.png": 54732,
	"./bab.png": 68591,
	"./bal.png": 64769,
	"./band.png": 17263,
	"./bat.png": 64809,
	"./bay.png": 68780,
	"./bcbc.png": 72126,
	"./bcc.png": 39848,
	"./bcd.png": 19463,
	"./bch.png": 96699,
	"./bcio.png": 56143,
	"./bcn.png": 86733,
	"./bco.png": 32836,
	"./bcpt.png": 63,
	"./bdl.png": 34,
	"./beam.png": 92231,
	"./bela.png": 69880,
	"./bix.png": 65053,
	"./blcn.png": 44247,
	"./blk.png": 67077,
	"./block.png": 51727,
	"./blz.png": 30796,
	"./bnb.png": 49726,
	"./bnt.png": 33336,
	"./bnty.png": 53675,
	"./booty.png": 10933,
	"./bos.png": 10892,
	"./bpt.png": 38198,
	"./bq.png": 13657,
	"./brd.png": 35052,
	"./bsd.png": 41943,
	"./bsv.png": 99093,
	"./btc.png": 75829,
	"./btcd.png": 47397,
	"./btch.png": 8953,
	"./btcp.png": 48369,
	"./btcz.png": 95003,
	"./btdx.png": 81352,
	"./btg.png": 26193,
	"./btm.png": 89179,
	"./bts.png": 41573,
	"./btt.png": 58346,
	"./btx.png": 53734,
	"./burst.png": 55310,
	"./bze.png": 96397,
	"./call.png": 59202,
	"./cc.png": 59824,
	"./cdn.png": 51969,
	"./cdt.png": 5531,
	"./cenz.png": 24666,
	"./chain.png": 19123,
	"./chat.png": 64348,
	"./chips.png": 82825,
	"./chsb.png": 21120,
	"./chz.png": 46481,
	"./cix.png": 46168,
	"./clam.png": 5161,
	"./cloak.png": 37856,
	"./cmm.png": 80217,
	"./cmt.png": 63336,
	"./cnd.png": 501,
	"./cnx.png": 27801,
	"./cny.png": 21552,
	"./cob.png": 61348,
	"./colx.png": 4392,
	"./comp.png": 93227,
	"./coqui.png": 28089,
	"./cred.png": 59686,
	"./crpt.png": 11773,
	"./crv.png": 99355,
	"./crw.png": 34002,
	"./cs.png": 70240,
	"./ctr.png": 18717,
	"./ctxc.png": 43404,
	"./cvc.png": 84946,
	"./d.png": 63292,
	"./dai.png": 15294,
	"./dash.png": 89782,
	"./dat.png": 24011,
	"./data.png": 75594,
	"./dbc.png": 19653,
	"./dcn.png": 10343,
	"./dcr.png": 17099,
	"./deez.png": 43590,
	"./dent.png": 34461,
	"./dew.png": 49724,
	"./dgb.png": 39759,
	"./dgd.png": 93817,
	"./dlt.png": 2788,
	"./dnt.png": 55742,
	"./dock.png": 10303,
	"./doge.png": 26685,
	"./dot.png": 94817,
	"./drgn.png": 16315,
	"./drop.png": 86829,
	"./dta.png": 42033,
	"./dth.png": 33632,
	"./dtr.png": 74186,
	"./ebst.png": 90966,
	"./eca.png": 63641,
	"./edg.png": 1326,
	"./edo.png": 83846,
	"./edoge.png": 2270,
	"./ela.png": 11456,
	"./elec.png": 22309,
	"./elf.png": 62783,
	"./elix.png": 12946,
	"./ella.png": 8696,
	"./emb.png": 98460,
	"./emc.png": 64997,
	"./emc2.png": 11027,
	"./eng.png": 34720,
	"./enj.png": 69077,
	"./entrp.png": 70853,
	"./eon.png": 56010,
	"./eop.png": 60548,
	"./eos.png": 15199,
	"./eqli.png": 62981,
	"./equa.png": 22206,
	"./etc.png": 86202,
	"./eth.png": 70089,
	"./ethos.png": 37931,
	"./etn.png": 43295,
	"./etp.png": 96897,
	"./eur.png": 26196,
	"./evx.png": 18255,
	"./exmo.png": 3389,
	"./exp.png": 41629,
	"./fair.png": 1296,
	"./fct.png": 25427,
	"./fida.png": 26512,
	"./fil.png": 22661,
	"./fjc.png": 20223,
	"./fldc.png": 29855,
	"./flo.png": 11749,
	"./flux.png": 36375,
	"./fsn.png": 82937,
	"./ftc.png": 20001,
	"./fuel.png": 38662,
	"./fun.png": 28059,
	"./game.png": 88208,
	"./gas.png": 3767,
	"./gbp.png": 10257,
	"./gbx.png": 98153,
	"./gbyte.png": 72329,
	"./generic.png": 36255,
	"./gin.png": 23754,
	"./glxt.png": 43399,
	"./gmr.png": 14074,
	"./gmt.png": 5484,
	"./gno.png": 98602,
	"./gnt.png": 30665,
	"./gold.png": 41000,
	"./grc.png": 74074,
	"./grin.png": 8812,
	"./grs.png": 13098,
	"./grt.png": 97765,
	"./gsc.png": 85517,
	"./gto.png": 93692,
	"./gup.png": 91376,
	"./gusd.png": 10135,
	"./gvt.png": 48401,
	"./gxs.png": 20772,
	"./gzr.png": 80603,
	"./hight.png": 46048,
	"./hns.png": 26109,
	"./hodl.png": 5885,
	"./hot.png": 32101,
	"./hpb.png": 5226,
	"./hsr.png": 68831,
	"./ht.png": 27990,
	"./html.png": 62329,
	"./huc.png": 40804,
	"./husd.png": 69466,
	"./hush.png": 71350,
	"./icn.png": 81034,
	"./icp.png": 31652,
	"./icx.png": 82444,
	"./ignis.png": 96346,
	"./ilk.png": 90358,
	"./ink.png": 68808,
	"./ins.png": 97232,
	"./ion.png": 99278,
	"./iop.png": 62208,
	"./iost.png": 33047,
	"./iotx.png": 99734,
	"./iq.png": 80980,
	"./itc.png": 53974,
	"./jnt.png": 46688,
	"./jpy.png": 74827,
	"./kcs.png": 10689,
	"./kin.png": 76086,
	"./klown.png": 87679,
	"./kmd.png": 25088,
	"./knc.png": 84098,
	"./krb.png": 59815,
	"./ksm.png": 36655,
	"./lbc.png": 54653,
	"./lend.png": 89029,
	"./leo.png": 27052,
	"./link.png": 31286,
	"./lkk.png": 26458,
	"./loom.png": 37653,
	"./lpt.png": 27752,
	"./lrc.png": 19629,
	"./lsk.png": 1010,
	"./ltc.png": 31739,
	"./lun.png": 36549,
	"./maid.png": 69967,
	"./mana.png": 98783,
	"./matic.png": 59770,
	"./max.png": 49946,
	"./mcap.png": 34245,
	"./mco.png": 25919,
	"./mda.png": 39856,
	"./mds.png": 97426,
	"./med.png": 92090,
	"./meetone.png": 56499,
	"./mft.png": 4059,
	"./miota.png": 51760,
	"./mith.png": 38932,
	"./mkr.png": 40290,
	"./mln.png": 39519,
	"./mnx.png": 14479,
	"./mnz.png": 13149,
	"./moac.png": 55610,
	"./mod.png": 24408,
	"./mona.png": 18257,
	"./msr.png": 30618,
	"./mth.png": 90961,
	"./mtl.png": 17301,
	"./music.png": 61081,
	"./mzc.png": 67840,
	"./nano.png": 976,
	"./nas.png": 82274,
	"./nav.png": 27983,
	"./ncash.png": 12839,
	"./ndz.png": 84344,
	"./nebl.png": 76915,
	"./neo.png": 60490,
	"./neos.png": 21579,
	"./neu.png": 68352,
	"./nexo.png": 16390,
	"./ngc.png": 15176,
	"./nio.png": 90182,
	"./nkn.png": 7961,
	"./nlc2.png": 64839,
	"./nlg.png": 36741,
	"./nmc.png": 74718,
	"./nmr.png": 54295,
	"./npxs.png": 20687,
	"./ntbc.png": 96217,
	"./nuls.png": 90094,
	"./nxs.png": 53661,
	"./nxt.png": 91938,
	"./oax.png": 44028,
	"./ok.png": 30044,
	"./omg.png": 41439,
	"./omni.png": 58317,
	"./one.png": 86232,
	"./ong.png": 76778,
	"./ont.png": 44625,
	"./oot.png": 37230,
	"./ost.png": 85978,
	"./ox.png": 26887,
	"./oxt.png": 4803,
	"./oxy.png": 84502,
	"./part.png": 36617,
	"./pasc.png": 84201,
	"./pasl.png": 55294,
	"./pax.png": 44131,
	"./paxg.png": 24740,
	"./pay.png": 54298,
	"./payx.png": 24840,
	"./pink.png": 90717,
	"./pirl.png": 5065,
	"./pivx.png": 30633,
	"./plr.png": 5286,
	"./poa.png": 38512,
	"./poe.png": 46100,
	"./polis.png": 40153,
	"./poly.png": 6704,
	"./pot.png": 93997,
	"./powr.png": 9494,
	"./ppc.png": 22123,
	"./ppp.png": 54784,
	"./ppt.png": 51460,
	"./pre.png": 31127,
	"./prl.png": 84422,
	"./pungo.png": 64303,
	"./pura.png": 58136,
	"./qash.png": 59281,
	"./qiwi.png": 75908,
	"./qlc.png": 19558,
	"./qnt.png": 52823,
	"./qrl.png": 94427,
	"./qsp.png": 91500,
	"./qtum.png": 48367,
	"./r.png": 75514,
	"./rads.png": 50038,
	"./rap.png": 24637,
	"./ray.png": 48380,
	"./rcn.png": 56349,
	"./rdd.png": 95226,
	"./rdn.png": 84640,
	"./ren.png": 42999,
	"./rep.png": 15177,
	"./repv2.png": 46913,
	"./req.png": 37056,
	"./rhoc.png": 94706,
	"./ric.png": 48334,
	"./rise.png": 21745,
	"./rlc.png": 57101,
	"./rpx.png": 71914,
	"./rub.png": 72795,
	"./rvn.png": 39018,
	"./ryo.png": 61906,
	"./safe.png": 18337,
	"./safemoon.png": 58410,
	"./sai.png": 64345,
	"./salt.png": 18154,
	"./san.png": 14950,
	"./sand.png": 26880,
	"./sbd.png": 45081,
	"./sberbank.png": 90394,
	"./sc.png": 44000,
	"./ser.png": 62966,
	"./shift.png": 34704,
	"./sib.png": 21410,
	"./sin.png": 19854,
	"./skl.png": 82662,
	"./sky.png": 67579,
	"./slr.png": 33269,
	"./sls.png": 97356,
	"./smart.png": 111,
	"./sngls.png": 71497,
	"./snm.png": 97076,
	"./snt.png": 85269,
	"./snx.png": 46825,
	"./soc.png": 55261,
	"./sol.png": 78666,
	"./spacehbit.png": 12451,
	"./spank.png": 511,
	"./sphtx.png": 37567,
	"./srn.png": 22915,
	"./stak.png": 56775,
	"./start.png": 56688,
	"./steem.png": 90420,
	"./storj.png": 24000,
	"./storm.png": 75327,
	"./stox.png": 52802,
	"./stq.png": 4918,
	"./strat.png": 7942,
	"./stx.png": 51623,
	"./sub.png": 52502,
	"./sumo.png": 82898,
	"./sushi.png": 47126,
	"./sys.png": 9899,
	"./taas.png": 65295,
	"./tau.png": 48370,
	"./tbx.png": 92569,
	"./tel.png": 84783,
	"./ten.png": 84445,
	"./tern.png": 5979,
	"./tgch.png": 83068,
	"./theta.png": 79276,
	"./tix.png": 55215,
	"./tkn.png": 31999,
	"./tks.png": 96106,
	"./tnb.png": 39048,
	"./tnc.png": 78993,
	"./tnt.png": 24014,
	"./tomo.png": 91013,
	"./tpay.png": 52264,
	"./trig.png": 90128,
	"./trtl.png": 7804,
	"./trx.png": 90998,
	"./tusd.png": 77246,
	"./tzc.png": 89597,
	"./ubq.png": 54514,
	"./uma.png": 88327,
	"./uni.png": 92078,
	"./unity.png": 70139,
	"./usd.png": 94996,
	"./usdc.png": 84085,
	"./usdt.png": 13578,
	"./utk.png": 930,
	"./veri.png": 91190,
	"./vet.png": 71041,
	"./via.png": 42944,
	"./vib.png": 97979,
	"./vibe.png": 98238,
	"./vivo.png": 99480,
	"./vrc.png": 6935,
	"./vrsc.png": 31292,
	"./vtc.png": 35441,
	"./vtho.png": 36207,
	"./wabi.png": 23837,
	"./wan.png": 23106,
	"./waves.png": 99666,
	"./wax.png": 89924,
	"./wbtc.png": 21466,
	"./wgr.png": 38232,
	"./wicc.png": 67140,
	"./wings.png": 70212,
	"./wpr.png": 78069,
	"./wtc.png": 87520,
	"./x.png": 81280,
	"./xas.png": 65720,
	"./xbc.png": 13737,
	"./xbp.png": 48514,
	"./xby.png": 15027,
	"./xcp.png": 56397,
	"./xdn.png": 66570,
	"./xem.png": 55866,
	"./xin.png": 87349,
	"./xlm.png": 83529,
	"./xmcc.png": 1741,
	"./xmg.png": 37624,
	"./xmo.png": 62256,
	"./xmr.png": 74389,
	"./xmy.png": 36118,
	"./xp.png": 60258,
	"./xpa.png": 72209,
	"./xpm.png": 41901,
	"./xpr.png": 81066,
	"./xrp.png": 87186,
	"./xsg.png": 41074,
	"./xtz.png": 26446,
	"./xuc.png": 68436,
	"./xvc.png": 46549,
	"./xvg.png": 27537,
	"./xzc.png": 62097,
	"./yfi.png": 5538,
	"./yoyow.png": 41911,
	"./zcl.png": 4887,
	"./zec.png": 84634,
	"./zel.png": 37517,
	"./zen.png": 59551,
	"./zest.png": 87540,
	"./zil.png": 97393,
	"./zilla.png": 96916,
	"./zrx.png": 88328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84920;